import React, { useState } from 'react';
import { FiSend, FiLoader } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AuditForm = ({ 
  city = "Alberta", 
  title, 
  subtitle, 
  buttonText = "Send Me The Report",
  type = "SEO" 
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 1500);
  };

  if (submitted) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
        <h3 className="text-2xl font-bold text-green-800 mb-2">Request Received!</h3>
        <p className="text-green-700">
          We are analyzing your request for {type} services. Expect your custom report in your inbox within 24 hours.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 md:p-8">
      <div className="mb-8">
        <h3 className="text-2xl font-bold text-slate-900 mb-2">
          {title || `Get Your Free ${type} Audit`}
        </h3>
        <p className="text-slate-600">
          {subtitle || `See exactly why your competitors are outranking you in ${city}. No obligation.`}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Website URL</label>
          <input 
            required 
            type="url" 
            placeholder="https://yourbusiness.com" 
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all" 
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
            <input 
              required 
              type="text" 
              placeholder="John Doe" 
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 outline-none" 
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Phone</label>
            <input 
              required 
              type="tel" 
              placeholder="(587) 555-0123" 
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 outline-none" 
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Email Address</label>
          <input 
            required 
            type="email" 
            placeholder="john@company.com" 
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-orange-500 outline-none" 
          />
        </div>
        <button 
          type="submit" 
          disabled={loading}
          className="w-full py-4 bg-slate-900 hover:bg-slate-800 text-white font-bold rounded-lg transition-all flex items-center justify-center gap-2 mt-2"
        >
          {loading ? (
            <>
              <SafeIcon icon={FiLoader} className="animate-spin" /> Analyzing...
            </>
          ) : (
            <>
              {buttonText} <SafeIcon icon={FiSend} />
            </>
          )}
        </button>
        <p className="text-xs text-center text-slate-400 mt-4">
          Your data is safe. We hate spam as much as you do.
        </p>
      </form>
    </div>
  );
};

export default AuditForm;